module.exports = __webpack_public_path__ + "media/images/nita-ae655c9899d16de99ec10edcd4d4c466.png";